import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import { RegisterForm } from '@/features/auth/components/RegisterForm';
import { Toaster } from 'sonner';

export function Register() {
  const { session, isInitialized } = useAuthStore();

  if (isInitialized && session) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
      <RegisterForm />
      <Toaster position="top-right" />
    </div>
  );
}
